import { UserRoles } from 'types';

const Permissions = {
  addPartsAndRecommendations: [
    UserRoles.SERVICE_MANAGER,
    UserRoles.SERVICE_ADVISOR,
    UserRoles.PARTS_ADVISOR,
    UserRoles.TECHNICIAN,
  ],
  addRoNotes: [
    UserRoles.SERVICE_MANAGER,
    UserRoles.SERVICE_ADVISOR,
    UserRoles.PARTS_ADVISOR,
    UserRoles.TECHNICIAN,
  ],
  // Gates Add photo and Delete; mirrors the ^/api/customer-photo POST/DELETE role list in
  // security.yaml (same as ^/api/repair-order-media) so both buttons match what the API accepts.
  manageCustomerPhotos: [
    UserRoles.SERVICE_MANAGER,
    UserRoles.SERVICE_ADVISOR,
    UserRoles.PARTS_ADVISOR,
    UserRoles.TECHNICIAN,
  ],
  canDeleteMPI: [UserRoles.SERVICE_MANAGER],
  canDeleteQuote: [UserRoles.SERVICE_ADVISOR, UserRoles.SERVICE_MANAGER, UserRoles.TECHNICIAN],
  canDeleteVideo: [UserRoles.SERVICE_MANAGER],
  canViewQuote: [
    UserRoles.SERVICE_MANAGER,
    UserRoles.SERVICE_ADVISOR,
    UserRoles.PARTS_ADVISOR,
    UserRoles.TECHNICIAN,
  ],
  canMarkMessageAsRead: [UserRoles.SERVICE_MANAGER],
  completeMpi: [UserRoles.SERVICE_MANAGER, UserRoles.TECHNICIAN],
  createCloseRo: [UserRoles.SERVICE_MANAGER, UserRoles.SERVICE_ADVISOR],
  deleteRo: [UserRoles.SERVICE_MANAGER],
  excludeCustomerFromRo: [UserRoles.SERVICE_MANAGER],
  financeReport: [UserRoles.SERVICE_MANAGER, UserRoles.SALES_AGENT, UserRoles.SALES_MANAGER],
  internalMessaging: [
    UserRoles.SERVICE_MANAGER,
    UserRoles.SERVICE_ADVISOR,
    UserRoles.PARTS_ADVISOR,
    UserRoles.TECHNICIAN,
  ],
  paymentsReport: [UserRoles.SERVICE_ADVISOR, UserRoles.SERVICE_MANAGER],
  partsReport: [UserRoles.SERVICE_MANAGER, UserRoles.PARTS_ADVISOR],
  serviceMessaging: [UserRoles.SERVICE_ADVISOR, UserRoles.SERVICE_MANAGER],
  salesMessaging: [
    // placeholder until implemented
  ],
  makeManualPayments: [
    UserRoles.SERVICE_ADVISOR,
    UserRoles.SALES_AGENT,
    UserRoles.PARTS_ADVISOR,
    UserRoles.SERVICE_MANAGER,
    UserRoles.SALES_MANAGER,
  ],
  // The ticket limits the Settings link to admins and service managers; ADMIN is appended to every
  // entry below.
  manageIserviceSettings: [UserRoles.SERVICE_MANAGER],
  manuallyConfirmQuote: [UserRoles.SERVICE_MANAGER, UserRoles.SERVICE_ADVISOR],
  requestPayments: [UserRoles.SERVICE_MANAGER, UserRoles.SERVICE_ADVISOR],
  sendQuoteToCustomer: [UserRoles.SERVICE_ADVISOR, UserRoles.SERVICE_MANAGER],
  reOpenROs: [UserRoles.ADMIN, UserRoles.SERVICE_MANAGER],
  setCustomerApprovalForQuote: [
    UserRoles.SERVICE_MANAGER,
    UserRoles.SERVICE_ADVISOR,
    UserRoles.PARTS_ADVISOR,
    UserRoles.TECHNICIAN,
  ],
  updateCustRoDetails: [UserRoles.SERVICE_MANAGER, UserRoles.SERVICE_ADVISOR],
  updateRoInRoDetails: [UserRoles.SERVICE_MANAGER, UserRoles.SERVICE_ADVISOR],
};

// add admin to all permissions in one place so we don't have to add it for each permission
Object.keys(Permissions).forEach((key) => {
  //@ts-expect-error - we know this is a valid key
  Permissions[key].push(UserRoles.ADMIN);
});

export { Permissions };
